import React from 'react';

const FormCard = function (props) {
  const {
    text, image, children,
  } = props;
  return (
    <div>
      {image && <img src={image} alt={text} />}
      {children}
    </div>
  );
};

export default FormCard;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/FormCard.js